<template>
    <div class="user-lists-modal delete-spot-from-list-dialog">
        <!-- Shadow -->
        <div class="user-lists-modal__shade" @click="closeModal"></div>

        <!-- Modal -->
        <div class="user-lists-modal__inner" v-if="currentList && spot">

            <!-- Close Modal -->
            <span class="user-lists-modal__close" @click="closeModal">
                <svg class='close'><use xlink:href="#close"></use></svg>
            </span>

            <!-- Header -->
            <h2>Delete From List</h2>
            <p>
                Are you sure you want to delete {{ spot.title }} from the list {{ list.name }}?
            </p>

            <!-- From -->
            <form :action="``" method="post" @submit.prevent="submit">
                <div class="form__button">
                    <button type="submit"
                            :class="{ 'is-submitting': form.isSubmitted }"
                            :disabled="form.isSubmitted"
                            class="button">
                        {{ form.isSubmitted ? 'Deleting From' : 'Delete From' + ' List' }}
                        <svg class='arrow-right-2'><use xlink:href="#arrow-right-2"></use></svg>
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>

import Form from '@/classes/Form'

export default {

    props: ['list'],

    data() {
        return {
            currentList: this.list,
            form: new Form({}),
            spot: null,
        }
    },

    created() {
        eventBus.$on('open-delete-spot-from-list-modal', data => {
            this.currentList = data.list;
            this.spot = data.spot;
            this.openModal();
        });
    },

    methods: {

        submit() {
            this.form.delete(`/lists/${this.currentList.id}/spot/${this.spot.slug}`)
                .then(response => {
                    eventBus.$emit('deleted-spot-from-list', response.list);
                    this.closeModal()
                })
                .catch(errors => {
                    console.log(errors)
                })
        },

        openModal(){
            $('.delete-spot-from-list-dialog').fadeIn()
        },

        closeModal(){
            $('.delete-spot-from-list-dialog').fadeOut();
        }
    }
}
</script>
